(function() {
  if (window.FlipsideAnalytics) return;

  var KEY = {
    visitor: 'flipside_vid_v1',
    session: 'flipside_sid_v1',
    firstTouch: 'flipside_touch_first_v1',
    lastTouch: 'flipside_touch_last_v1',
    funnel: 'flipside_funnel_v1',
    abandonment: 'flipside_abandon_v1'
  };

  var DEDUPE_MS = 1200;
  var SCROLL_DEPTHS = [25, 50, 75, 90];
  var dedupe = {};

  function str(v) { return typeof v === 'string' ? v : (v == null ? '' : String(v)); }
  function jsonParse(v, fallback) { try { return JSON.parse(v); } catch (e) { return fallback; } }
  function getJson(storage, key, fallback) {
    try {
      var raw = storage.getItem(key);
      return raw ? jsonParse(raw, fallback) : fallback;
    } catch (e) {
      return fallback;
    }
  }
  function setJson(storage, key, value) {
    try { storage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }
  function ensureId(storage, key, prefix) {
    var existing = '';
    try { existing = storage.getItem(key) || ''; } catch (e) {}
    if (existing) return existing;
    var fresh = prefix + '_' + Math.random().toString(36).slice(2, 10) + '_' + Date.now().toString(36);
    try { storage.setItem(key, fresh); } catch (e) {}
    return fresh;
  }
  function emailDomain(email) {
    var v = str(email).trim().toLowerCase();
    var at = v.lastIndexOf('@');
    if (at <= 0 || at >= v.length - 1) return '';
    return v.slice(at + 1);
  }
  function clean(obj) {
    var out = {};
    Object.keys(obj || {}).forEach(function(k) {
      var v = obj[k];
      if (v === undefined || v === null || v === '') return;
      out[k] = v;
    });
    return out;
  }

  function cleanPayload(payload) {
    var sanitized = clean(payload || {});
    var blocked = {
      email: 1,
      contact_email: 1,
      customer_email: 1,
      phone: 1,
      contact_phone: 1,
      first_name: 1,
      last_name: 1,
      name: 1
    };
    Object.keys(sanitized).forEach(function(key) {
      if (blocked[str(key).toLowerCase()]) delete sanitized[key];
    });
    return sanitized;
  }

  var visitorId = ensureId(window.localStorage, KEY.visitor, 'vis');
  var sessionId = ensureId(window.sessionStorage, KEY.session, 'ses');

  function parseQuery() {
    var out = {};
    var q = str(window.location.search).replace(/^\?/, '');
    if (!q) return out;
    q.split('&').forEach(function(pair) {
      if (!pair) return;
      var p = pair.split('=');
      var k = decodeURIComponent(p[0] || '').trim();
      if (!k) return;
      out[k] = decodeURIComponent(p.slice(1).join('=') || '').trim();
    });
    return out;
  }

  function hostnameFromRef(ref) {
    var value = str(ref);
    if (!value) return '';
    try { return new URL(value).hostname || value; } catch (e) { return value; }
  }

  function touchFromLocation() {
    var q = parseQuery();
    return {
      utm_source: q.utm_source || q.source || '',
      utm_medium: q.utm_medium || '',
      utm_campaign: q.utm_campaign || '',
      utm_content: q.utm_content || '',
      utm_term: q.utm_term || '',
      gclid: q.gclid || '',
      fbclid: q.fbclid || '',
      msclkid: q.msclkid || '',
      ttclid: q.ttclid || '',
      referrer: hostnameFromRef(document.referrer || ''),
      landing_page: window.location.pathname + (window.location.search || ''),
      seen_at: new Date().toISOString()
    };
  }

  function hasTouch(t) {
    return !!(t && (t.utm_source || t.utm_medium || t.utm_campaign || t.gclid || t.fbclid || t.msclkid || t.ttclid || t.referrer));
  }

  function refreshTouch() {
    var first = getJson(window.localStorage, KEY.firstTouch, null);
    var last = getJson(window.localStorage, KEY.lastTouch, null);
    var current = touchFromLocation();

    if (!first && hasTouch(current)) {
      first = current;
      setJson(window.localStorage, KEY.firstTouch, first);
    }

    if (hasTouch(current)) {
      last = current;
      setJson(window.localStorage, KEY.lastTouch, last);
    }

    return { first: first || {}, last: last || {} };
  }

  function attribution() {
    var t = refreshTouch();
    var first = t.first || {};
    var last = t.last || {};
    return {
      utm_source: str(last.utm_source || ''),
      utm_medium: str(last.utm_medium || ''),
      utm_campaign: str(last.utm_campaign || ''),
      utm_content: str(last.utm_content || ''),
      utm_term: str(last.utm_term || ''),
      gclid: str(last.gclid || first.gclid || ''),
      fbclid: str(last.fbclid || first.fbclid || ''),
      msclkid: str(last.msclkid || first.msclkid || ''),
      ttclid: str(last.ttclid || first.ttclid || ''),
      landing_page: str(last.landing_page || first.landing_page || ''),
      referrer: str(last.referrer || first.referrer || ''),
      first_touch_source: str(first.utm_source || first.referrer || ''),
      first_touch_campaign: str(first.utm_campaign || ''),
      last_touch_source: str(last.utm_source || last.referrer || ''),
      last_touch_campaign: str(last.utm_campaign || '')
    };
  }

  function findState(form) {
    if (!form) return '';
    var select = form.querySelector('select[id^="state-"]');
    if (select && select.value) return str(select.value).trim().toUpperCase();
    return '';
  }

  function formContext(form) {
    return str(form.getAttribute('data-form-context') || form.id || form.getAttribute('name') || 'unknown').toLowerCase();
  }

  function dedupeTags(raw) {
    var seen = {};
    var out = [];
    str(raw).split(',').forEach(function(tag) {
      var t = tag.trim();
      if (!t) return;
      var k = t.toLowerCase();
      if (seen[k]) return;
      seen[k] = true;
      out.push(t);
    });
    return out;
  }

  function ensureHidden(form, name, value) {
    if (!form || !name) return;
    var existing = form.querySelector('input[name="' + name.replace(/"/g, '\"') + '"]');
    if (!existing) {
      existing = document.createElement('input');
      existing.type = 'hidden';
      existing.name = name;
      form.appendChild(existing);
    }
    existing.value = value;
  }

  function enrichForm(form) {
    if (!form || form.__flipside_enriched) return;

    var hasCustomerEmail = !!form.querySelector('input[name="customer[email]"]');
    var hasAnyEmail = hasCustomerEmail || !!form.querySelector('input[name="contact[email]"], input[type="email"]');
    if (!hasAnyEmail) return;

    var prefix = hasCustomerEmail ? 'customer' : 'contact';
    var ctx = formContext(form);
    var stateCode = findState(form);
    var att = attribution();

    ensureHidden(form, prefix + '[note][utm_source]', att.utm_source);
    ensureHidden(form, prefix + '[note][utm_medium]', att.utm_medium);
    ensureHidden(form, prefix + '[note][utm_campaign]', att.utm_campaign);
    ensureHidden(form, prefix + '[note][utm_content]', att.utm_content);
    ensureHidden(form, prefix + '[note][utm_term]', att.utm_term);
    ensureHidden(form, prefix + '[note][gclid]', att.gclid);
    ensureHidden(form, prefix + '[note][fbclid]', att.fbclid);
    ensureHidden(form, prefix + '[note][msclkid]', att.msclkid);
    ensureHidden(form, prefix + '[note][ttclid]', att.ttclid);
    ensureHidden(form, prefix + '[note][landing_page]', att.landing_page);
    ensureHidden(form, prefix + '[note][referrer]', att.referrer);
    ensureHidden(form, prefix + '[note][session_id]', sessionId);
    ensureHidden(form, prefix + '[note][visitor_id]', visitorId);
    ensureHidden(form, prefix + '[note][first_touch_source]', att.first_touch_source);
    ensureHidden(form, prefix + '[note][first_touch_campaign]', att.first_touch_campaign);
    ensureHidden(form, prefix + '[note][last_touch_source]', att.last_touch_source);
    ensureHidden(form, prefix + '[note][last_touch_campaign]', att.last_touch_campaign);
    ensureHidden(form, prefix + '[note][signup_context]', ctx);

    // An inquiry keeps attribution but does not receive marketing automation tags.
    if (form.getAttribute('data-fmc-inquiry-only') === 'true') {
      form.__flipside_enriched = true;
      return;
    }

    var tagName = prefix + '[tags]';
    var tagInput = form.querySelector('input[name="' + tagName.replace(/"/g, '\"') + '"]');
    if (!tagInput) {
      tagInput = document.createElement('input');
      tagInput.type = 'hidden';
      tagInput.name = tagName;
      form.appendChild(tagInput);
    }

    var current = dedupeTags(tagInput.value);
    var additions = [
      'automation-welcome',
      'automation-drop-alert',
      'src-' + ctx.replace(/[^a-z0-9-]/gi, '-').replace(/-+/g, '-').replace(/^-|-$/g, '')
    ];

    if (stateCode) additions.push('state-' + stateCode);
    if (att.utm_source) additions.push('utm-source-' + att.utm_source.replace(/[^a-z0-9-]/gi, '-').toLowerCase());
    if (att.utm_campaign) additions.push('utm-campaign-' + att.utm_campaign.replace(/[^a-z0-9-]/gi, '-').toLowerCase());

    tagInput.value = dedupeTags(current.concat(additions).join(',')).join(',');
    form.__flipside_enriched = true;
  }

  function enrichCommerceForm(form) {
    if (!form || form.__flipside_commerce_enriched) return;

    var action = str(form.getAttribute('action') || '').toLowerCase();
    var isProductAdd = action.indexOf('/cart/add') > -1 || !!form.querySelector('input[name="id"]');
    var isCart = action === '/cart' || action.indexOf('/cart?') === 0 || !!form.querySelector('input[name^="updates["]');
    if (!isProductAdd && !isCart) return;

    var att = attribution();
    function setIf(name, value) {
      if (!str(value)) return;
      ensureHidden(form, name, value);
    }

    if (isProductAdd) {
      setIf('properties[_utm_source]', att.utm_source);
      setIf('properties[_utm_medium]', att.utm_medium);
      setIf('properties[_utm_campaign]', att.utm_campaign);
      setIf('properties[_utm_content]', att.utm_content);
      setIf('properties[_utm_term]', att.utm_term);
      setIf('properties[_gclid]', att.gclid);
      setIf('properties[_fbclid]', att.fbclid);
      setIf('properties[_msclkid]', att.msclkid);
      setIf('properties[_ttclid]', att.ttclid);
      setIf('properties[_session_id]', sessionId);
      setIf('properties[_visitor_id]', visitorId);
      setIf('properties[_landing_page]', att.landing_page);
    }

    if (isCart) {
      setIf('attributes[utm_source]', att.utm_source);
      setIf('attributes[utm_medium]', att.utm_medium);
      setIf('attributes[utm_campaign]', att.utm_campaign);
      setIf('attributes[utm_content]', att.utm_content);
      setIf('attributes[utm_term]', att.utm_term);
      setIf('attributes[gclid]', att.gclid);
      setIf('attributes[fbclid]', att.fbclid);
      setIf('attributes[msclkid]', att.msclkid);
      setIf('attributes[ttclid]', att.ttclid);
      setIf('attributes[session_id]', sessionId);
      setIf('attributes[visitor_id]', visitorId);
      setIf('attributes[last_touch_source]', att.last_touch_source);
      setIf('attributes[last_touch_campaign]', att.last_touch_campaign);
    }

    form.__flipside_commerce_enriched = true;
  }

  function enrichAllForms() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      enrichForm(forms[i]);
      enrichCommerceForm(forms[i]);
    }
  }

  function appendAttributionParams(parts, prefix) {
    var p = str(prefix || 'contact');
    var att = attribution();
    function add(name, value) {
      if (!str(value)) return;
      parts.push(encodeURIComponent(name) + '=' + encodeURIComponent(value));
    }
    add(p + '[note][utm_source]', att.utm_source);
    add(p + '[note][utm_medium]', att.utm_medium);
    add(p + '[note][utm_campaign]', att.utm_campaign);
    add(p + '[note][utm_content]', att.utm_content);
    add(p + '[note][utm_term]', att.utm_term);
    add(p + '[note][gclid]', att.gclid);
    add(p + '[note][fbclid]', att.fbclid);
    add(p + '[note][msclkid]', att.msclkid);
    add(p + '[note][ttclid]', att.ttclid);
    add(p + '[note][landing_page]', att.landing_page);
    add(p + '[note][referrer]', att.referrer);
    add(p + '[note][session_id]', sessionId);
    add(p + '[note][visitor_id]', visitorId);
    add(p + '[note][first_touch_source]', att.first_touch_source);
    add(p + '[note][first_touch_campaign]', att.first_touch_campaign);
    add(p + '[note][last_touch_source]', att.last_touch_source);
    add(p + '[note][last_touch_campaign]', att.last_touch_campaign);
    return parts;
  }

  function shouldDedupe(eventName, payload) {
    var key = eventName + '|' + str(payload.form || '') + '|' + str(payload.source || '');
    var now = Date.now();
    var last = Number(dedupe[key] || 0);
    if (last && (now - last) < DEDUPE_MS) return true;
    dedupe[key] = now;
    return false;
  }

  function getFunnel() {
    return getJson(window.localStorage, KEY.funnel, {
      counts: {
        flipside_waitlist_submit: 0,
        flipside_waitlist_success: 0,
        flipside_email_submit: 0,
        flipside_email_success: 0,
        flipside_add_to_cart: 0,
        flipside_begin_checkout: 0,
        flipside_purchase: 0
      },
      updated_at: ''
    });
  }

  function bumpFunnel(eventName) {
    var tracked = {
      flipside_waitlist_submit: 1,
      flipside_waitlist_success: 1,
      flipside_email_submit: 1,
      flipside_email_success: 1,
      flipside_add_to_cart: 1,
      flipside_begin_checkout: 1,
      flipside_purchase: 1
    };
    if (!tracked[eventName]) return;
    var f = getFunnel();
    f.counts[eventName] = Number(f.counts[eventName] || 0) + 1;
    f.updated_at = new Date().toISOString();
    setJson(window.localStorage, KEY.funnel, f);
  }

  function startAbandonment(payload) {
    var state = {
      started_at: Date.now(),
      email_domain: str(payload && payload.email_domain),
      source: str(payload && payload.source),
      checkout_value: Number(payload && payload.checkout_value || 0) || 0,
      prompted_1h: false,
      prompted_24h: false
    };
    setJson(window.localStorage, KEY.abandonment, state);
    return state;
  }

  function clearAbandonment() {
    try { window.localStorage.removeItem(KEY.abandonment); } catch (e) {}
  }

  function getAbandonment() {
    return getJson(window.localStorage, KEY.abandonment, null);
  }

  function parseMoneyText(value) {
    var raw = str(value).replace(/[^0-9.,-]/g, '').trim();
    if (!raw) return 0;
    if (raw.indexOf(',') > -1 && raw.indexOf('.') > -1) raw = raw.replace(/,/g, '');
    else if (raw.indexOf(',') > -1 && raw.indexOf('.') === -1) raw = raw.replace(/,/g, '.');
    var n = Number(raw);
    return isFinite(n) ? n : 0;
  }

  function productContextFromDom() {
    var pathHandle = (window.location.pathname.split('/products/')[1] || '').split(/[?#]/)[0];
    var ctx = {
      product_handle: pathHandle || ''
    };

    var titleEl = document.querySelector('.product-info__title, .mc-title, h1');
    var vendorEl = document.querySelector('.product-info__vendor, .mc-vendor, [data-product-vendor]');
    var priceEl = document.querySelector('.product-info__price, .mc-price, [data-product-price], .price');
    var variantInput = document.querySelector('form[action*="/cart/add"] [name="id"], #product-form [name="id"]');

    if (titleEl) ctx.product_title = str(titleEl.textContent || '').trim();
    if (vendorEl) ctx.product_vendor = str(vendorEl.textContent || '').trim();
    if (variantInput && variantInput.value) ctx.variant_id = str(variantInput.value);

    if (priceEl) {
      var p = parseMoneyText(priceEl.textContent || '');
      if (p > 0) ctx.item_price = p;
    }

    if (window.meta && window.meta.product) {
      var mp = window.meta.product;
      if (mp.id) ctx.product_id = str(mp.id);
      if (mp.title && !ctx.product_title) ctx.product_title = str(mp.title);
      if (mp.vendor && !ctx.product_vendor) ctx.product_vendor = str(mp.vendor);
      if (mp.type) ctx.product_type = str(mp.type);
      if (mp.selectedVariantId && !ctx.variant_id) ctx.variant_id = str(mp.selectedVariantId);
    }

    var ldNodes = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < ldNodes.length; i++) {
      var parsed = jsonParse(ldNodes[i].textContent || '', null);
      var list = Array.isArray(parsed) ? parsed : [parsed];
      for (var j = 0; j < list.length; j++) {
        var node = list[j] || {};
        if (node['@type'] !== 'Product') continue;
        if (node.name && !ctx.product_title) ctx.product_title = str(node.name);
        if (node.brand && !ctx.product_vendor) {
          if (typeof node.brand === 'string') ctx.product_vendor = str(node.brand);
          else if (node.brand.name) ctx.product_vendor = str(node.brand.name);
        }
        if (node.sku && !ctx.variant_id) ctx.variant_id = str(node.sku);
        if (!ctx.item_price && node.offers) {
          var offer = Array.isArray(node.offers) ? node.offers[0] : node.offers;
          var offerPrice = Number(offer && offer.price || 0);
          if (isFinite(offerPrice) && offerPrice > 0) ctx.item_price = offerPrice;
        }
        break;
      }
      if (ctx.product_title && (ctx.item_price || ctx.variant_id || ctx.product_id)) break;
    }

    if (!ctx.currency) ctx.currency = 'USD';
    return clean(ctx);
  }

  function buildAnalyticsItems(payload) {
    var quantity = Number(payload.quantity || 1);
    if (!isFinite(quantity) || quantity < 1) quantity = 1;

    var price = Number(payload.item_price || payload.price || 0);
    if (!isFinite(price) || price <= 0) price = 0;

    var item = clean({
      item_id: str(payload.variant_id || payload.product_id || payload.product_handle || ''),
      item_name: str(payload.product_title || payload.item_name || ''),
      item_brand: str(payload.product_vendor || ''),
      item_category: str(payload.product_type || ''),
      item_variant: str(payload.variant_title || ''),
      quantity: quantity,
      price: price > 0 ? price : undefined
    });

    if (!item.item_id && !item.item_name) return [];
    return [item];
  }

  function pushGtag(eventName, payload) {
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', eventName, payload);

    if (eventName === 'flipside_waitlist_success' || eventName === 'flipside_email_success') {
      window.gtag('event', 'generate_lead', {
        method: payload.form || payload.source || 'waitlist',
        campaign: payload.utm_campaign || '',
        value: 1,
        currency: payload.currency || 'USD'
      });
      return;
    }

    if (eventName === 'flipside_view_product' || eventName === 'flipside_view_item') {
      var viewItems = buildAnalyticsItems(payload);
      var viewPayload = { currency: payload.currency || 'USD' };
      var viewVal = Number(payload.item_price || payload.price || 0);
      if (isFinite(viewVal) && viewVal > 0) viewPayload.value = viewVal;
      if (viewItems.length) viewPayload.items = viewItems;
      window.gtag('event', 'view_item', viewPayload);
      return;
    }

    if (eventName === 'flipside_add_to_cart' || eventName === 'flipside_add_to_cart_success') {
      var atcItems = buildAnalyticsItems(payload);
      var atcValue = Number(payload.checkout_value || payload.value || payload.item_price || 0);
      if ((!isFinite(atcValue) || atcValue <= 0) && atcItems.length && atcItems[0].price) {
        atcValue = Number(atcItems[0].price || 0) * Number(atcItems[0].quantity || 1);
      }
      var atcPayload = { currency: payload.currency || 'USD' };
      if (isFinite(atcValue) && atcValue > 0) atcPayload.value = atcValue;
      if (atcItems.length) atcPayload.items = atcItems;
      window.gtag('event', 'add_to_cart', atcPayload);
      return;
    }

    if (eventName === 'flipside_begin_checkout') {
      var beginItems = buildAnalyticsItems(payload);
      var beginValue = Number(payload.checkout_value || payload.value || 0);
      var beginPayload = { currency: payload.currency || 'USD' };
      if (isFinite(beginValue) && beginValue > 0) beginPayload.value = beginValue;
      if (beginItems.length) beginPayload.items = beginItems;
      window.gtag('event', 'begin_checkout', beginPayload);
      return;
    }

    if (eventName === 'flipside_purchase') {
      var purchaseItems = buildAnalyticsItems(payload);
      var purchaseValue = Number(payload.checkout_value || payload.value || payload.item_price || 0);
      var purchasePayload = {
        currency: payload.currency || 'USD',
        transaction_id: str(payload.order_id || payload.checkout_token || payload.session_id || ('txn_' + Date.now()))
      };
      if (isFinite(purchaseValue) && purchaseValue > 0) purchasePayload.value = purchaseValue;
      if (purchaseItems.length) purchasePayload.items = purchaseItems;
      window.gtag('event', 'purchase', purchasePayload);
    }
  }

  function pushMeta(eventName, payload) {
    /* DISABLED 2026-07-09 (double-fire, observed live): the Facebook & Instagram channel's
       web pixel runs in OPEN context and already sends every standard event (AddToCart,
       InitiateCheckout, Purchase, Lead) to pixel 235398220707316 via fbq('trackShopify',...).
       This bridge fired a SECOND copy of each into the same pixel with no shared eventID,
       so Meta double-counted (one ATC click = two AddToCart events, caught 2026-07-09).
       The channel is the canonical sender (CAPI-capable). Re-enable ONLY if the channel
       pixel is removed. */
    return;
    if (typeof window.fbq !== 'function') return;

    var contentIds = [];
    if (payload.variant_id) contentIds.push(str(payload.variant_id));
    else if (payload.product_id) contentIds.push(str(payload.product_id));

    if (eventName === 'flipside_add_to_cart' || eventName === 'flipside_add_to_cart_success') {
      var atcValue = Number(payload.checkout_value || payload.value || payload.item_price || payload.tip_amount || 0) || 0;
      if (atcValue <= 0) atcValue = Number(payload.item_price || 0) * Number(payload.quantity || 1);
      window.fbq('track', 'AddToCart', {
        value: atcValue > 0 ? atcValue : 0,
        currency: payload.currency || 'USD',
        content_ids: contentIds,
        content_name: payload.product_title || '',
        content_type: 'product'
      });
      return;
    }

    if (eventName === 'flipside_begin_checkout') {
      window.fbq('track', 'InitiateCheckout', {
        value: Number(payload.checkout_value || payload.value || 0) || 0,
        currency: payload.currency || 'USD',
        content_ids: contentIds,
        content_type: 'product'
      });
      return;
    }

    if (eventName === 'flipside_purchase') {
      window.fbq('track', 'Purchase', {
        value: Number(payload.checkout_value || payload.value || 0) || 0,
        currency: payload.currency || 'USD',
        content_ids: contentIds,
        content_type: 'product'
      });
      return;
    }

    if (eventName === 'flipside_waitlist_success' || eventName === 'flipside_email_success') {
      window.fbq('track', 'Lead', {
        content_name: payload.form || payload.source || 'waitlist',
        status: 'subscribed'
      });
      return;
    }

    window.fbq('trackCustom', eventName, payload);
  }

  function track(eventName, payload, options) {
    var opts = options || {};
    var base = {
      session_id: sessionId,
      visitor_id: visitorId,
      page_path: window.location.pathname,
      page_title: document.title,
      event_time: new Date().toISOString()
    };
    var merged = cleanPayload(Object.assign({}, attribution(), base, payload || {}));

    if (!opts.bypassDedupe && shouldDedupe(eventName, merged)) return;

    bumpFunnel(eventName);

    if (eventName === 'flipside_begin_checkout') startAbandonment(merged);
    if (eventName === 'flipside_purchase') clearAbandonment();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, merged));

    pushGtag(eventName, merged);
    pushMeta(eventName, merged);

    document.dispatchEvent(new CustomEvent('flipside:track', {
      detail: { event: eventName, payload: merged }
    }));
  }

  function showRecovery(stage, state) {
    var id = 'flipside-recovery-' + stage;
    if (document.getElementById(id)) return;

    var wrap = document.createElement('div');
    wrap.id = id;
    wrap.style.cssText = 'position:fixed;bottom:1.25rem;left:1.25rem;z-index:99997;background:#0a0a0a;border:1px solid rgba(201,162,77,.35);padding:.75rem .9rem;max-width:300px;color:#fff;font-family:Courier New,monospace;box-shadow:0 14px 32px rgba(0,0,0,.45)';
    wrap.innerHTML = '<div style="font-size:.62rem;letter-spacing:.1em;text-transform:uppercase;color:#C9A24D;margin-bottom:.35rem;">Cart Recovery</div><div style="font-size:.72rem;line-height:1.4;color:#d4d4d4;margin-bottom:.6rem;">You still have items waiting. Resume checkout before this drop moves.</div><div style="display:flex;gap:.5rem;align-items:center;"><a href="/cart" style="background:#C9A24D;color:#000;text-decoration:none;padding:.45rem .65rem;font-size:.62rem;letter-spacing:.08em;text-transform:uppercase;">Resume</a><button type="button" data-close style="background:transparent;border:1px solid #333;color:#999;padding:.42rem .6rem;font-size:.62rem;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;">Dismiss</button></div>';
    document.body.appendChild(wrap);

    var closeBtn = wrap.querySelector('[data-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
      });
    }

    track('flipside_abandonment_recovery_prompt', {
      source: 'abandonment_recovery',
      stage: stage,
      email_domain: str(state && state.email_domain),
      checkout_value: Number(state && state.checkout_value || 0) || 0
    }, { bypassDedupe: true });
  }

  function maybeRecoveryPrompt() {
    var st = getAbandonment();
    if (!st || !st.started_at) return;
    if (window.location.pathname.indexOf('/checkout') === 0) return;

    var elapsed = Date.now() - Number(st.started_at || 0);
    if (elapsed >= 86400000 && !st.prompted_24h) {
      st.prompted_24h = true;
      setJson(window.localStorage, KEY.abandonment, st);
      showRecovery('24h', st);
      return;
    }

    if (elapsed >= 3600000 && !st.prompted_1h) {
      st.prompted_1h = true;
      setJson(window.localStorage, KEY.abandonment, st);
      showRecovery('1h', st);
    }
  }

  function renderDashboard() {
    if (window.location.search.indexOf('funnel=1') === -1 && window.location.hash.indexOf('funnel=1') === -1) return;

    var panel = document.createElement('div');
    panel.id = 'flipside-funnel-dashboard';
    panel.style.cssText = 'position:fixed;top:1rem;left:1rem;z-index:99998;background:#0a0a0a;border:1px solid rgba(201,162,77,.4);padding:.85rem;min-width:260px;max-width:320px;color:#fff;font-family:Courier New,monospace;box-shadow:0 14px 32px rgba(0,0,0,.45)';

    function pct(a, b) {
      var n = Number(a || 0);
      var d = Number(b || 0);
      if (!d) return '0%';
      return ((n / d) * 100).toFixed(1) + '%';
    }

    function draw() {
      var f = getFunnel().counts || {};
      var submit = Number(f.flipside_waitlist_submit || 0);
      var success = Number(f.flipside_waitlist_success || 0);
      var emailSubmit = Number(f.flipside_email_submit || 0);
      var emailSuccess = Number(f.flipside_email_success || 0);
      var atc = Number(f.flipside_add_to_cart || 0);
      var checkout = Number(f.flipside_begin_checkout || 0);
      var purchase = Number(f.flipside_purchase || 0);
      var a = attribution();

      panel.innerHTML = '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:.5rem;"><strong style="font-size:.64rem;letter-spacing:.12em;text-transform:uppercase;color:#C9A24D;">Funnel Dashboard</strong><button type="button" data-close style="background:none;border:none;color:#777;font-size:.85rem;cursor:pointer;">×</button></div><div style="font-size:.67rem;line-height:1.6;">Waitlist Submit: <b>' + submit + '</b><br>Waitlist Success: <b>' + success + '</b> (' + pct(success, submit) + ')<br>Email Submit: <b>' + emailSubmit + '</b><br>Email Success: <b>' + emailSuccess + '</b> (' + pct(emailSuccess, emailSubmit) + ')<br>Add To Cart: <b>' + atc + '</b> (' + pct(atc, success || submit) + ')<br>Begin Checkout: <b>' + checkout + '</b> (' + pct(checkout, atc || success) + ')<br>Purchase: <b>' + purchase + '</b> (' + pct(purchase, checkout) + ')</div><div style="margin-top:.55rem;padding-top:.45rem;border-top:1px solid #1f1f1f;font-size:.58rem;line-height:1.4;color:#8d8d8d;">Last source: ' + (a.utm_source || a.referrer || 'direct') + '<br>Campaign: ' + (a.utm_campaign || 'none') + '<br>Session: ' + sessionId + '</div>';

      var closeBtn = panel.querySelector('[data-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          if (panel && panel.parentNode) panel.parentNode.removeChild(panel);
        });
      }
    }

    draw();
    setInterval(draw, 4000);
    document.body.appendChild(panel);
  }

  function trackScrollDepth() {
    var fired = {};
    function onScroll() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      var pct = Math.round((window.scrollY / max) * 100);
      for (var i = 0; i < SCROLL_DEPTHS.length; i++) {
        var depth = SCROLL_DEPTHS[i];
        if (pct >= depth && !fired[depth]) {
          fired[depth] = true;
          track('flipside_scroll_depth', { source: 'scroll', depth: depth });
        }
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function trackTimeMilestones() {
    [30, 60, 180].forEach(function(seconds) {
      setTimeout(function() {
        track('flipside_time_on_page', { source: 'engagement', seconds: seconds });
      }, seconds * 1000);
    });
  }

  function trackProductView() {
    if (window.location.pathname.indexOf('/products/') !== 0) return;
    var handle = (window.location.pathname.split('/products/')[1] || '').split(/[?#]/)[0];
    var productCtx = productContextFromDom();
    if (!productCtx.product_handle) productCtx.product_handle = handle;
    var payload = Object.assign({ source: 'product_page' }, productCtx);
    track('flipside_view_product', payload, { bypassDedupe: true });
    track('flipside_view_item', payload, { bypassDedupe: true });
  }

  function trackCustomerPosted() {
    if (window.location.search.indexOf('customer_posted=true') === -1) return;
    var form = str(window.location.hash).replace(/^#/, '') || 'customer_form';
    track('flipside_waitlist_success', { source: 'customer_posted', form: form }, { bypassDedupe: true });
    track('flipside_automation_enqueued', { source: 'customer_posted', form: form, automation: 'welcome_and_drop_alert' }, { bypassDedupe: true });
  }

  function trackPurchaseProxy() {
    var p = window.location.pathname || '';
    if (p.indexOf('/thank_you') > -1 || p.indexOf('/orders/') > -1) {
      track('flipside_purchase', { source: 'checkout_proxy' }, { bypassDedupe: true });
    }
  }

  function onSubmitCapture(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    enrichForm(form);
    enrichCommerceForm(form);

    var action = str(form.getAttribute('action') || '').toLowerCase();
    var isAddToCart = action.indexOf('/cart/add') > -1 || !!form.querySelector('input[name="id"]');
    if (isAddToCart) {
      var qtyInput = form.querySelector('input[name="quantity"]');
      var qty = Number(qtyInput && qtyInput.value ? qtyInput.value : 1);
      if (!isFinite(qty) || qty < 1) qty = 1;

      var idInput = form.querySelector('select[name="id"], input[name="id"]');
      var variantId = str(idInput && idInput.value ? idInput.value : '');
      var ctx = productContextFromDom();

      track('flipside_add_to_cart', Object.assign({
        source: 'product_form_submit',
        form: formContext(form),
        variant_id: variantId,
        quantity: qty
      }, ctx), { bypassDedupe: true });
    }

    var emailInput = form.querySelector('input[type="email"], input[name*="[email]"]');
    if (!emailInput || !emailInput.value) return;

    var context = formContext(form);
    var stateCode = findState(form);
    var domain = emailDomain(emailInput.value);
    var hasExplicitTracking = str(form.getAttribute('data-flipside-explicit-events')) === '1';

    track('flipside_email_capture_submit', {
      source: 'form_submit',
      form: context,
      email_domain: domain,
      state: stateCode || ''
    });

    if (!hasExplicitTracking && (context.indexOf('waitlist') > -1 || context.indexOf('newsletter') > -1 || context.indexOf('footer-email-form') > -1 || context.indexOf('exit-email-form') > -1 || context.indexOf('drop') > -1)) {
      track('flipside_waitlist_submit', {
        source: 'email_capture',
        form: context,
        email_domain: domain,
        state: stateCode || ''
      });
    }
  }

  function onInvalidCapture(e) {
    var target = e.target;
    if (!target || !target.form) return;
    var context = formContext(target.form);
    track('flipside_form_error', {
      source: 'form_validation',
      form: context,
      field: str(target.name || target.id || 'unknown')
    });
  }

  function onClickCapture(e) {
    var link = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!link) return;

    var href = str(link.getAttribute('href') || '');
    var label = str(link.textContent || '').trim().slice(0, 100);
    var url = null;
    try { url = new URL(href, window.location.origin); } catch (e0) { url = null; }

    if (href === '#waitlist' || href.indexOf('/#waitlist') === 0) {
      track('flipside_waitlist_click', { source: 'cta_link', label: label });
      return;
    }

    if (url && url.origin === window.location.origin && (url.pathname === '/checkout' || url.pathname.indexOf('/checkout/') === 0)) {
      e.preventDefault();

      var att = attribution();
      var checkoutAttrs = {
        utm_source: att.utm_source,
        utm_medium: att.utm_medium,
        utm_campaign: att.utm_campaign,
        utm_content: att.utm_content,
        utm_term: att.utm_term,
        gclid: att.gclid,
        fbclid: att.fbclid,
        msclkid: att.msclkid,
        ttclid: att.ttclid,
        session_id: sessionId,
        visitor_id: visitorId
      };

      Object.keys(checkoutAttrs).forEach(function(key) {
        if (!checkoutAttrs[key]) return;
        url.searchParams.set('attributes[' + key + ']', checkoutAttrs[key]);
      });

      var destinationHref = url.toString();
      var navigated = false;
      function goCheckout() {
        if (navigated) return;
        navigated = true;
        window.location.href = destinationHref;
      }

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(cart) {
          var payload = {
            source: 'checkout_click',
            form: 'checkout_link',
            route: '/checkout',
            label: label,
            currency: (cart && cart.currency) || 'USD'
          };

          if (cart) {
            payload.item_count = Number(cart.item_count || 0) || 0;
            payload.checkout_value = Number(cart.total_price || 0) / 100;
            if (cart.items && cart.items.length) {
              var item = cart.items[0];
              payload.product_title = str(item.product_title || item.title || '');
              payload.product_id = str(item.product_id || '');
              payload.variant_id = str(item.variant_id || '');
              payload.quantity = Number(item.quantity || 1) || 1;
              payload.item_price = Number(item.final_price || item.price || 0) / 100;
            }
          }

          track('flipside_begin_checkout', payload, { bypassDedupe: true });
        })
        .catch(function() {
          track('flipside_begin_checkout', {
            source: 'checkout_click',
            form: 'checkout_link',
            route: '/checkout',
            label: label
          }, { bypassDedupe: true });
        })
        .finally(function() {
          setTimeout(goCheckout, 80);
        });

      setTimeout(goCheckout, 700);
      return;
    }

    if (url && /^https?:$/i.test(url.protocol) && url.origin !== window.location.origin) {
      var destination = '';
      try { destination = url.hostname; } catch (e2) { destination = href; }
      track('flipside_outbound_click', { source: 'link_click', label: label, destination: destination });
    }
  }

  function pickExperimentVariant(name, variants) {
    var key = 'flipside_exp_' + name;
    var current = '';
    try { current = str(window.localStorage.getItem(key)); } catch (e) { current = ''; }
    if (!current) {
      var idx = Math.floor(Math.random() * variants.length);
      current = variants[idx] || variants[0];
      try { window.localStorage.setItem(key, current); } catch (e2) {}
    }
    if (variants.indexOf(current) === -1) current = variants[0];
    return current;
  }

  function trackExperiment(name, variant) {
    track('flipside_experiment_view', {
      source: 'experiment',
      experiment: name,
      variant: variant
    }, { bypassDedupe: true });
  }

  function runExperiments() {
    if (window.location.pathname !== '/' && window.location.pathname !== '') return;

    var heroVariant = pickExperimentVariant('hero_headline_v1', ['control', 'alt']);
    var heroTitle = document.querySelector('.hero-banner__title');
    // hero title rewrite removed — theme settings control hero copy
    trackExperiment('hero_headline_v1', heroVariant);

    var ctaVariant = pickExperimentVariant('waitlist_cta_v1', ['control', 'alt']);
    var waitlistButton = document.querySelector('#waitlist .waitlist-form__btn');
    if (waitlistButton && ctaVariant === 'alt') waitlistButton.textContent = 'Get Early Access';
    trackExperiment('waitlist_cta_v1', ctaVariant);

    var orderVariant = pickExperimentVariant('home_section_order_v1', ['control', 'alt']);
    if (orderVariant === 'alt') {
      var waitlistSection = document.getElementById('shopify-section-waitlist_signup_EnUnqi') || document.querySelector('[id*="waitlist_signup"]');
      var reviewsSection = document.getElementById('shopify-section-product_reviews_c4g4Em') || document.querySelector('[id*="product_reviews"]');
      if (waitlistSection && reviewsSection && reviewsSection.parentNode) {
        reviewsSection.parentNode.insertBefore(waitlistSection, reviewsSection);
      }
    }
    trackExperiment('home_section_order_v1', orderVariant);
  }

  window.FlipsideAnalytics = {
    track: track,
    emailDomain: emailDomain,
    getAttribution: attribution,
    getFunnel: getFunnel,
    appendAttributionParams: appendAttributionParams,
    enrichForm: enrichForm,
    startAbandonment: startAbandonment,
    clearAbandonment: function(reason) {
      clearAbandonment();
      if (reason) track('flipside_abandonment_cleared', { source: 'abandonment', reason: str(reason) }, { bypassDedupe: true });
    }
  };

  document.addEventListener('submit', onSubmitCapture, true);
  document.addEventListener('invalid', onInvalidCapture, true);
  document.addEventListener('click', onClickCapture, true);

  enrichAllForms();
  if ('MutationObserver' in window) {
    new MutationObserver(enrichAllForms).observe(document.documentElement, { childList: true, subtree: true });
  }

  trackProductView();
  trackCustomerPosted();
  trackPurchaseProxy();

  function runNonCritical() {
    trackScrollDepth();
    trackTimeMilestones();
    maybeRecoveryPrompt();
    renderDashboard();
    runExperiments();
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(runNonCritical, { timeout: 1500 });
  } else {
    setTimeout(runNonCritical, 300);
  }
})();
